import Collector from 'amkit3-modules/v/statistic/collector'
import * as HuyaAdEvent from 'amkit3-modules/v/player/huya/ad-event'

import HuyaStatisticEvent from './statistic-event'

class HuyaCollector extends Collector {
  constructor(player) {
    super(player)

    this.player.on(HuyaAdEvent.LOAD, () => this.emit(HuyaStatisticEvent.AD_LOAD))
    this.player.on(HuyaAdEvent.CLICK, () => this.emit(HuyaStatisticEvent.AD_CLICK))
    this.player.on(HuyaAdEvent.COMPLETE, () => this.emit(HuyaStatisticEvent.AD_COMPLETE))
    this.player.on(HuyaAdEvent.ERROR, () => this.emit(HuyaStatisticEvent.AD_ERROR))
    this.player.on(HuyaAdEvent.NO_AD, () => this.emit(HuyaStatisticEvent.AD_NONE))
  }
  getAid() {
    if (this.player.getAid) return this.player.getAid()
    else return ''
  }
  getAti() {
    if (this.player.getAti) return this.player.getAti()
    else return ''
  }
  getCode() {
    if (this.player.getCode) return this.player.getCode()
    else return ''
  }
}

export default HuyaCollector
